<script setup lang="ts">
import { ref } from 'vue'
import ScoreInfo from './score/ScoreInfo.vue'
import ToggleGroup from './ui/toggle-group/ToggleGroup.vue'
import ToggleGroupItem from './ui/toggle-group/ToggleGroupItem.vue'
import Typography from './ui/typography/Typography.vue'

const deposit = ref('1')

const deposits = [
  { value: '1', title: 'BB 1$' },
  { value: '10', title: 'BB 10$' },
  { value: '50', title: 'BB 50$' },
  { value: '100', title: 'BB 100$' }
]
</script>

<template>
  <div class="w-full rounded-lg bg-dark-grey p-[14px] text-white mb-[24px] font-poppins">
    <Typography size="text-16-24" class="font-semibold mb-[12px]">{{
      $t('EndSession.label.RankBenefits')
    }}</Typography>
    <div class="flex flex-row mb-[12px]">
      <ToggleGroup v-model="deposit" type="single">
        <ToggleGroupItem v-for="deposit in deposits" :value="deposit.value" variant="rounded">{{
          deposit.title
        }}</ToggleGroupItem>
      </ToggleGroup>
    </div>
    <div class="flex flex-row">
      <ScoreInfo class="bg-menu-item-bg mr-[12px]" value="+34$" title="Earnings from $100 bank" />
      <ScoreInfo class="bg-menu-item-bg" value="0.22" title="Avg. profitability/ session" />
    </div>
  </div>
</template>
